module.exports = __webpack_public_path__ + "img/add_gray.1f292aea.svg";